import React from 'react'


const PopularCategory = () => {
    return (
        <>
            <div className='maincontainer'>
                <div className="row mt-5">
                    <div className="col-lg-12">
                        <div className='single-culumn'>
                            <div className=' text-center'>
                                <h3 className='category-title'>Popular Category</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-3 col-md-4 col-sm-6">
                        <div className="categories-imagebox">
                            <div className="categories-thumbnail">
                                <img src={`assets/images/${"Mask group (1)"}.png`} alt="" />
                            </div>
                            <div className="categories-content">
                                <div className="categories-content-box-inner text-center">
                                    <p>manager</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6">
                        <div className="categories-imagebox">
                            <div className="categories-thumbnail">
                                <img src={`assets/images/${"Mask group (1)"}.png`} alt="" />
                            </div>
                            <div className="categories-content">
                                <div className="categories-content-box-inner text-center">
                                    <p>manager</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6">
                        <div className="categories-imagebox">
                            <div className="categories-thumbnail">
                                <img src={`assets/images/${"Mask group (1)"}.png`} alt="" />
                            </div>
                            <div className="categories-content">
                                <div className="categories-content-box-inner text-center">
                                    <p>manager</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6">
                        <div className="categories-imagebox">
                            <div className="categories-thumbnail">
                                <img src={`assets/images/${"Mask group (1)"}.png`} alt="" />
                            </div>
                            <div className="categories-content">
                                <div className="categories-content-box-inner text-center">
                                    <p>manager</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="row mt-2">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className='categories-style-2'>
                            <div className="categories-imagebox">
                                <div className="categories-thumbnail">
                                    <img src={`assets/images/${"Mask group (1)"}.png`} alt="" />
                                </div>
                                <div className="categories-content">
                                    <div className="categories-content-box-inner text-center">
                                        <p>manager</p>
                                    </div>
                                </div>
                            </div>
                            <div className="categories-imagebox">
                                <div className="categories-thumbnail">
                                    <img src={`assets/images/${"Mask group (1)"}.png`} alt="" />
                                </div>
                                <div className="categories-content">
                                    <div className="categories-content-box-inner text-center">
                                        <p>manager</p>
                                    </div>
                                </div>
                            </div>
                            <div className="categories-imagebox">
                                <div className="categories-thumbnail">
                                    <img src={`assets/images/${"Mask group (1)"}.png`} alt="" />
                                </div>
                                <div className="categories-content">
                                    <div className="categories-content-box-inner text-center">
                                        <p>manager</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>


                </div>
                <div className="row mt-4">
                    <div className="col-lg-3 col-md-4 col-sm-6">
                        <div className="categories-imagebox">
                            <div className="categories-thumbnail">
                                <img src={`assets/images/${"Mask group (1)"}.png`} alt="" />
                            </div>
                            <div className="categories-content">
                                <div className="categories-content-box-inner text-center">
                                    <p>manager</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6">
                        <div className="categories-imagebox">
                            <div className="categories-thumbnail">
                                <img src={`assets/images/${"Mask group (1)"}.png`} alt="" />
                            </div>
                            <div className="categories-content">
                                <div className="categories-content-box-inner text-center">
                                    <p>manager</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6">
                        <div className="categories-imagebox">
                            <div className="categories-thumbnail">
                                <img src={`assets/images/${"Mask group (1)"}.png`} alt="" />
                            </div>
                            <div className="categories-content">
                                <div className="categories-content-box-inner text-center">
                                    <p>manager</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6">
                        <div className="categories-imagebox">
                            <div className="categories-thumbnail">
                                <img src={`assets/images/${"Mask group (1)"}.png`} alt="" />
                            </div>
                            <div className="categories-content">
                                <div className="categories-content-box-inner text-center">
                                    <p>manager</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default PopularCategory;